let ShowCode = [
  {
    path: '/show_code_details',
    name: '就诊码',
    component: () => import('@/pages/uCode/showCodeDetail.vue')
  }
]

export default ShowCode
